module.exports = "/location-inactive-eab929d0d8cb07a136cc8f0ac07176f0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Map/CreateRoute/LocationMarkerGroup/LocationMarker/icons/location-inactive.svg
// module id = IcA+
// module chunks = 4